export Layout from "./Layout";

export AbsoluteLayout from "./AbsoluteLayout";

//card
export CardLayout from "./card/CardLayout";

export HorizontalLayout from "./HorizontalLayout";
export VerticalLayout from "./VerticalLayout";

//center
export CenterLayout from "./center/CenterLayout";
export VerticalCenterLayout from "./center/VerticalCenterLayout";
export HorizontalCenterLayout from "./center/HorizontalCenterLayout";

//adapt
export HorizontalAdaptLayout from "./adapt/HorizontalAdaptLayout";
export VerticalAdaptLayout from "./adapt/VerticalAdaptLayout";

//tape
export HtapeLayout from "./tape/HtapeLayout";
export VtapeLayout from "./tape/VtapeLayout";

//flow
export LeftLayout from "./flow/LeftLayout";
export RightLayout from "./flow/RightLayout";

//fill
export FillLayout from "./fill/FillLayout";
export HorizontalFillLayout from "./fill/HorizontalFillLayout";
export VerticalFillLayout from "./fill/VerticalFillLayout";

export BorderLayout from "./border/BorderLayout";
export GridLayout from "./grid/GridLayout";



// WEBPACK FOOTER //
// ./layout/index.js